import {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

import {EventGroupType} from '../../api';

interface Props {
  open: boolean;
  onClose: () => void;
  onCreate: (groupType: EventGroupType) => void;
  isCreating?: boolean;
}

export const CreateEventGroupDialog = ({
  open,
  onClose,
  onCreate,
  isCreating,
}: Props) => {
  const [groupType, setGroupType] = useState<EventGroupType>('VERTICAL');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{paper: {sx: {width: 360, p: 2}}}}
    >
      <DialogTitle>Create group</DialogTitle>
      <DialogContent>
        <RadioGroup
          value={groupType}
          onChange={(_, value) => setGroupType(value as EventGroupType)}
        >
          <FormControlLabel
            value="VERTICAL"
            control={<Radio />}
            label="Vertical"
          />
          <FormControlLabel
            value="HORIZONTAL"
            control={<Radio />}
            label="Horizontal"
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isCreating}>
          Cancel
        </Button>
        <Button onClick={() => onCreate(groupType)} disabled={isCreating}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
